import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { ProductTypeName } from 'services/productTypes/types';
import { makeSelectProductTypeFieldValue } from 'services/products/selectors';

export interface OwnProps {
    productId: ProductId;
}

export interface ConnectedProps {
    productType: ProductTypeName;
}

type Props = OwnProps & ConnectedProps;

export class SummaryProductTypeListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { productType } = this.props;

        return <ListItem description="Type" value={productType} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productType: makeSelectProductTypeFieldValue()
});

export default connect(mapStateToProps)(SummaryProductTypeListItemComponent);
